import ApiService from "@/common/api.service";

const PATH = "stock/write-offs";

export const GET_STOCK_WRITE_OFFS = "getStockWriteOffs";
export const GET_STOCK_WRITE_OFF = "getStockWriteOff";
export const CREATE_STOCK_WRITE_OFF = "createStockWriteOff";
export const UPDATE_STOCK_WRITE_OFF = "updateStockWriteOff";
export const FINALIZE_STOCK_WRITE_OFF = "finalizeStockWriteOff";
export const CANCEL_STOCK_WRITE_OFF = "cancelStockWriteOff";
export const DISCARD_STOCK_WRITE_OFF = "discardStockWriteOff";
export const GET_STOCK_WRITE_OFF_SUGGEST_LOTS = "getStockWriteOffSuggestLots";
export const GET_STOCK_WRITE_OFF_SUGGEST_DRAFT_LOTS = "getStockWriteOffSuggestDraftLots";
export const GET_STOCK_WRITE_OFF_REASON_OPTIONS = "getStockWriteOffReasonOptions";
export const UPLOAD_STOCK_WRITE_OFF_FILES = "uploadStockWriteOffFiles";
export const DELETE_STOCK_WRITE_OFF_FILE = "deleteStockWriteOffFile";
export const DOWNLOAD_STOCK_WRITE_OFF_FILE = "downloadStockWriteOffFile";
export const REGENERATE_STOCK_WRITE_OFF_DOCUMENT = "regenerateStockWriteOffDocument";

const actions = {
  [GET_STOCK_WRITE_OFFS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_WRITE_OFF](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_WRITE_OFF](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_WRITE_OFF](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [FINALIZE_STOCK_WRITE_OFF](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/finalize`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CANCEL_STOCK_WRITE_OFF](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/cancel`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DISCARD_STOCK_WRITE_OFF](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/discard`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_WRITE_OFF_SUGGEST_LOTS](context, payload) {
    const writeOffId = payload.writeOffId || payload.id;
    const params = payload.params || {};

    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/${writeOffId}/suggest-lots`, params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_WRITE_OFF_SUGGEST_DRAFT_LOTS](context, payload) {
    const params = (payload && payload.params) || {};

    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/suggest-lots`, params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_WRITE_OFF_REASON_OPTIONS]() {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/action-reasons/options", { scope: "write_off" })
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPLOAD_STOCK_WRITE_OFF_FILES](context, payload) {
    const formData = new FormData();
    (payload.files || []).forEach((file) => formData.append("files[]", file));

    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/files`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_WRITE_OFF_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${payload.id}/files/${payload.fileId}`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DOWNLOAD_STOCK_WRITE_OFF_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${PATH}/${payload.id}/files/${payload.fileId}/download`,
        payload.originalName || payload.name || "download"
      )
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },

  [REGENERATE_STOCK_WRITE_OFF_DOCUMENT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/regenerate-document`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
};
